import { Store } from 'libx'
import { computed, observable, action } from 'mobx'
import { task } from 'mobx-task'
import debounce from 'lodash/debounce'
import WorkspaceDetailsState from './screens/WorkspaceManagement/WorkspaceDetailsState'
import NewWorkspaceState from './screens/WorkspaceManagement/NewWorkspaceState'
import { browserHistory } from 'react-router'
import link from 'misc/link'

export default class WorkspaceManagementStore extends Store {
  @observable
  selected = null

  @observable
  view = { type: 'none' }

  @observable
  searchText = ''

  @observable
  debouncedSearchText = ''

  _applyDebouncedSearch = debounce(
    action((text) => {
      this.debouncedSearchText = text
    }),
    300
  )

  @computed
  get workspaces() {
    const lowerCaseSearchText = this.debouncedSearchText.toLowerCase()
    if (this.debouncedSearchText) {
      return this.rootStore.workspaceStore.workspaces.filter(
        (w) =>
          w.name.toLowerCase().includes(lowerCaseSearchText) ||
          w.slug.toLowerCase().includes(lowerCaseSearchText)
      )
    }
    return this.rootStore.workspaceStore.workspaces.slice()
  }

  @task.resolved
  async activate(idOrSlug) {
    const user = this.rootStore.sessionStore.user
    if (!user.platformAdmin) {
      throw new Error('You are not a platform administrator.')
    }

    await this.rootStore.workspaceStore.find()

    this.showWorkspaceDetails(idOrSlug)
  }

  @action.bound
  changeSearchText(newSearchText) {
    this.searchText = newSearchText
    this._applyDebouncedSearch(newSearchText)
  }

  @action.bound
  showWorkspaceDetails(idOrSlug) {
    const found = idOrSlug
      ? this.rootStore.workspaceStore.workspaces.find(
          (x) => x.id === idOrSlug || x.slug === idOrSlug
        )
      : null

    if (found) {
      this.select(found)
    }
  }

  @action.bound
  async select(workspace) {
    this.selected = workspace
    this.view = new WorkspaceDetailsState({
      workspace,
      workspaceManagementStore: this,
      rootStore: this.rootStore,
    })

    await this.view.activate()

    browserHistory.push(link.workspaceManagementDetails(workspace.slug))
  }

  @action.bound
  async newWorkspace() {
    this.selected = null
    this.view = new NewWorkspaceState({
      rootStore: this.rootStore,
      workspaceManagementStore: this,
    })

    await this.view.activate()

    browserHistory.push(link.workspaceManagement())
  }
}
